(function () {
  'use strict';

  if (window.__arvenneTrackerInit) return;
  window.__arvenneTrackerInit = true;

  if (window.Shopify && window.Shopify.designMode) return;

  var cfg = window.__arvenneAnalyticsConfig || {};
  var ENDPOINT = cfg.endpoint || '/apps/shop/shop/track';
  var PAGE_TYPE = cfg.pageType || '';
  var CURRENCY = cfg.currency || '';
  var LOGGED_IN = cfg.loggedIn === true;
  var LOGIN_PENDING_KEY = 'arvenne_login_pending';

  var THEME_ROLE = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '';
  var ENVIRONMENT = THEME_ROLE === 'main' ? 'production' : 'development';

  var ANON_KEY = 'arvenne_anonymous_id';
  var UTM_KEY = 'arvenne_utms';
  var UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  function getAnonymousId() {
    var id = null;
    try { id = localStorage.getItem(ANON_KEY); } catch (e) {}
    if (!id) {
      id = (window.crypto && crypto.randomUUID)
        ? crypto.randomUUID()
        : 'anon-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
      try { localStorage.setItem(ANON_KEY, id); } catch (e) {}
    }
    return id;
  }

  function resolveUtms() {
    // First-touch: once captured, the original attribution is never overwritten.
    try {
      var stored = localStorage.getItem(UTM_KEY);
      if (stored) {
        var parsed = JSON.parse(stored);
        if (parsed && Object.keys(parsed).length) return parsed;
      }
    } catch (e) {}

    var params = new URLSearchParams(location.search);
    var found = {};
    var hasNew = false;
    UTM_PARAMS.forEach(function (k) {
      var v = params.get(k);
      if (v) { found[k] = v; hasNew = true; }
    });
    if (hasNew) {
      try { localStorage.setItem(UTM_KEY, JSON.stringify(found)); } catch (e) {}
      return found;
    }
    return {};
  }

  // Ad click ids: Google Ads (gclid/gbraid/wbraid) and Meta (fbclid). Unlike
  // UTMs these are last-touch: each network credits the most recent ad click,
  // and the ids expire (gclid ~90 days), so a newer click overwrites the stored
  // one. The two networks are independent: a Meta click must not erase a stored
  // Google id, and vice versa.
  var CLICK_ID_KEY = 'arvenne_click_ids';
  var GOOGLE_CLICK_ID_PARAMS = ['gclid', 'gbraid', 'wbraid'];

  function captureClickIds() {
    var params = new URLSearchParams(location.search);
    var google = {};
    var hasGoogle = false;
    GOOGLE_CLICK_ID_PARAMS.forEach(function (k) {
      var v = params.get(k);
      if (v) { google[k] = v; hasGoogle = true; }
    });
    var fbclid = params.get('fbclid');
    if (!hasGoogle && !fbclid) return;

    var stored = {};
    try { stored = JSON.parse(localStorage.getItem(CLICK_ID_KEY) || '{}') || {}; } catch (e) {}

    if (hasGoogle) {
      // A new Google click replaces the whole Google set (no stale wbraid
      // beside a fresh gclid).
      GOOGLE_CLICK_ID_PARAMS.forEach(function (k) { delete stored[k]; });
      Object.assign(stored, google, { captured_at: Date.now() });
    }
    if (fbclid) {
      // Meta builds _fbc as fb.1.<click time in ms>.<fbclid>, so keep the time.
      stored.fbclid = fbclid;
      stored.fbclid_at = Date.now();
    }
    try { localStorage.setItem(CLICK_ID_KEY, JSON.stringify(stored)); } catch (e) {}
  }

  captureClickIds();

  var ANON_ID = getAnonymousId();
  var UTMS = resolveUtms();

  function send(event, properties) {
    var payload = JSON.stringify({
      event: event,
      anonymous_id: ANON_ID,
      timestamp: Date.now(),
      properties: Object.assign(
        { page_url: location.href, environment: ENVIRONMENT, theme_role: THEME_ROLE },
        properties || {},
        UTMS
      )
    });
    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([payload], { type: 'application/json' });
        if (navigator.sendBeacon(ENDPOINT, blob)) return;
      }
    } catch (e) {}
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
        credentials: 'same-origin'
      }).catch(function () {});
    } catch (e) {}
  }

  window.arvenneTrack = send;

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function toMoney(cents) {
    return typeof cents === 'number' ? cents / 100 : cents;
  }

  function trackLoginCompletion() {
    try {
      if (LOGGED_IN && sessionStorage.getItem(LOGIN_PENDING_KEY)) {
        sessionStorage.removeItem(LOGIN_PENDING_KEY);
        send('login_completed', { location: 'account' });
      }
    } catch (e) {}
  }

  function trackPageView() {
    trackLoginCompletion();

    send('page_viewed', {
      page_type: PAGE_TYPE,
      pathname: location.pathname,
      referrer: document.referrer || ''
    });

    if (PAGE_TYPE === 'product') {
      var product = readJson('ProductAnalyticsData');
      if (product) send('product_viewed', product);
    } else if (PAGE_TYPE === 'collection') {
      var collection = readJson('CollectionAnalyticsData');
      if (collection) send('collection_viewed', collection);
    } else if (PAGE_TYPE === 'search') {
      var search = readJson('SearchAnalyticsData');
      if (search && search.query) send('search_submitted', search);
    }
  }

  var cartSnapshot = null;
  var ADD_SOURCE_TTL = 6000;
  var lastAddContext = null;

  function indexCart(cart) {
    var map = {};
    if (cart && cart.items) {
      cart.items.forEach(function (item) { map[item.key] = item; });
    }
    return map;
  }

  function addSourceFor(el) {
    if (!el || !el.closest) return null;
    var tagged = el.closest('[data-add-source]');
    if (tagged) return tagged.getAttribute('data-add-source');
    if (el.closest('.cart-drawer-crosssell')) return 'complemente_sua_compra';
    if (el.closest('quick-add-modal, .quick-add-modal')) return 'quick_view';
    if (el.closest('.quantity__button')) return 'cart_drawer';
    if (el.closest('.card--product, .card-wrapper')) return 'product_card';
    if (el.closest('product-form')) return PAGE_TYPE === 'product' ? 'product_page' : 'other';
    return null;
  }

  document.addEventListener('click', function (e) {
    var src = addSourceFor(e.target);
    if (src) lastAddContext = { source: src, at: Date.now() };
  }, true);

  function resolveAddLocation() {
    if (lastAddContext && (Date.now() - lastAddContext.at) < ADD_SOURCE_TTL) {
      return lastAddContext.source;
    }
    return PAGE_TYPE === 'product' ? 'product_page' : '';
  }

  function emitAdd(item, quantity, currency) {
    send('product_added_to_cart', {
      product_id: item.product_id,
      product_title: item.product_title,
      variant_id: item.variant_id,
      variant_title: item.variant_title,
      sku: item.sku,
      quantity: quantity,
      price: toMoney(item.final_price != null ? item.final_price : item.price),
      currency: currency,
      location: resolveAddLocation()
    });
  }

  function diffCart(cart) {
    if (!cart || !cart.items) return;
    var next = indexCart(cart);
    var currency = cart.currency || CURRENCY;

    if (cartSnapshot) {
      Object.keys(next).forEach(function (key) {
        var prevQty = cartSnapshot[key] ? cartSnapshot[key].quantity : 0;
        var delta = next[key].quantity - prevQty;
        if (delta > 0) emitAdd(next[key], delta, currency);
      });

      Object.keys(cartSnapshot).forEach(function (key) {
        var prev = cartSnapshot[key];
        var nowQty = next[key] ? next[key].quantity : 0;
        if (nowQty < prev.quantity) {
          send('product_removed_from_cart', {
            product_id: prev.product_id,
            product_title: prev.product_title,
            variant_id: prev.variant_id,
            sku: prev.sku,
            quantity: prev.quantity - nowQty
          });
        }
      });
    }

    cartSnapshot = next;
  }

  var origFetch = window.fetch ? window.fetch.bind(window) : null;
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var diffScheduled = false;

  function fetchCart() {
    (origFetch || window.fetch)('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(diffCart)
      .catch(function () {});
  }

  function scheduleCartDiff() {
    if (diffScheduled) return;
    diffScheduled = true;
    setTimeout(function () { diffScheduled = false; fetchCart(); }, 150);
  }

  if (origFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string'
        ? input
        : (input && input.url) ? input.url : String(input || '');
      var promise = origFetch(input, init);
      if (CART_MUTATION.test(url)) {
        promise.then(function (res) { if (res && res.ok) scheduleCartDiff(); }).catch(function () {});
      }
      return promise;
    };
  }

  fetchCart();

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('.about__accordion-toggle');
    if (!toggle || toggle.classList.contains('active')) return;
    if ((toggle.textContent || '').toLowerCase().indexOf('especifica') === -1) return;

    var product = readJson('ProductAnalyticsData') || {};
    send('technical_specs_opened', {
      product_id: product.product_id,
      product_title: product.product_title,
      variant_id: product.variant_id,
      section_name: 'technical_specs'
    });
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/account/login') === -1) return;
    if (!form.querySelector('[name="customer[password]"]')) return;
    try { sessionStorage.setItem(LOGIN_PENDING_KEY, '1'); } catch (err) {}
    send('login_started', { location: 'login_page' });
  }, true);

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-track]');
    if (!el) return;
    var event = el.getAttribute('data-track');
    if (!event) return;
    send(event, {
      location: el.getAttribute('data-track-location') || '',
      button_text: (el.getAttribute('data-track-text') || el.textContent || '').trim().slice(0, 120)
    });
  });

  function cartTotals() {
    var total = 0, qty = 0, n = 0;
    if (cartSnapshot) {
      Object.keys(cartSnapshot).forEach(function (k) {
        var it = cartSnapshot[k];
        qty += it.quantity || 0;
        total += it.final_line_price != null
          ? it.final_line_price
          : (it.final_price != null ? it.final_price : it.price || 0) * (it.quantity || 0);
        n += 1;
      });
    }
    return { cart_total: toMoney(total), item_count: qty, distinct_items: n };
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cart__checkout-button');
    if (!btn) return;
    var t = cartTotals();
    send('checkout_started', {
      cart_total: t.cart_total,
      currency: CURRENCY,
      item_count: t.item_count,
      distinct_items: t.distinct_items,
      location: 'cart_drawer'
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackPageView);
  } else {
    trackPageView();
  }
})();
